import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.32054 3.79978C10.5058 1.73341 13.4943 1.73341 14.6795 3.79976L22.3386 17.1451C23.5181 19.2009 22.0241 21.75 19.659 21.75H4.34104C1.9753 21.75 0.480565 19.201 1.66169 17.1448L9.32054 3.79978ZM13 8.5C13 7.94772 12.5523 7.5 12 7.5C11.4477 7.5 11 7.94772 11 8.5V13.5C11 14.0523 11.4477 14.5 12 14.5C12.5523 14.5 13 14.0523 13 13.5V8.5ZM12 16C11.6248 16 11.3332 16.1776 11.1554 16.3554C10.9775 16.5332 10.8 16.8248 10.8 17.2C10.8 17.5752 10.9775 17.8668 11.1554 18.0446C11.3332 18.2225 11.6248 18.4 12 18.4C12.3752 18.4 12.6667 18.2225 12.8446 18.0446C13.0224 17.8668 13.2 17.5752 13.2 17.2C13.2 16.8248 13.0224 16.5332 12.8446 16.3554C12.6668 16.1776 12.3752 16 12 16Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
